// What the colour control shows, as plain data (unify-ui ship 4b) — no DOM here, so node runs it (test/colours.test.js).
// `core` is what the tool hands the control (the core's filaments subpath, COLOUR_CORE: FILAMENTS, BRAND, filamentHint,
// nearestFilament — ruling R87: nothing here imports the core). Three kinds of colour (team rule 6, an item of two lists):
//   a FILAMENTS hex  → its name                                  ("White")
//   a BRAND hex      → its name and its hand-picked nearest      ("Filasophy Violet", "≈ Purple")
//   any other hex    → the visitor's own: S.customCaption and the nearest filament by R98's metric ("Custom", "≈ Grey")

// The one form of a colour the control hands a tool: upper-case #RRGGBB (I9 — pet-tag's link check takes nothing else; an
// <input type="color"> gives lower case). Anything that is not a colour → null.
export const normalHex = (v) => (/^#[0-9a-fA-F]{6}$/.test(String(v ?? '')) ? String(v).toUpperCase() : null);

// The caption under a part's swatch: its lines, in order (the first line names the colour, a second one says "≈ <filament>").
export function captionLines(hex, S, core) {
  const h = normalHex(hex);
  if (!h) return [S.customCaption];
  const hint = core.filamentHint(h);
  if (hint && hint.nearest) return [hint.name, `≈ ${hint.nearest}`];
  if (hint) return [hint.name];
  return [S.customCaption, `≈ ${core.nearestFilament(h).name}`];
}

// The swatch button's accessible name: the part, then what its caption says ("Base — Filasophy Ink ≈ Black").
export const swatchName = (label, hex, S, core) => `${label} — ${captionLines(hex, S, core).join(' ')}`;

// Is this colour one the visitor chose themselves (not a filament, not a brand colour)?
export const isOwn = (hex, core) => { const h = normalHex(hex); return !!h && !core.filamentHint(h); };

// The palette that is lit: the first look whose every colour is its part's colour now (`parts` [{ key, value }]) — as each
// tool's own lookKey / lookLabel reads it — or null.
export function litLook(parts, looks) {
  const now = Object.fromEntries(parts.map((p) => [p.key, normalHex(p.value)]));
  const on = looks.find((l) => Object.entries(l.colours).every(([k, hex]) => Object.hasOwn(now, k) && now[k] === normalHex(hex)));
  return on ? on.key : null;
}

// What makes the rows themselves (not their colours): a change here rebuilds them (and calls `extra` again); a change of a
// colour only repaints. A part's `off`: undefined, 'disabled', 'hidden' or 'veiled'.
export const rowsKey = (parts) => JSON.stringify(parts.map((p) => [p.key, p.label]));
export const looksKey = (looks) => JSON.stringify(looks.map((l) => [l.key, l.name, l.colours]));
